import React, { useState } from 'react';
import styles from './style.module.scss';
import { CiUser } from 'react-icons/ci';
import { AiOutlineLock } from 'react-icons/ai';
import { BsArrowUpRight, BsEye, BsEyeSlash } from 'react-icons/bs';
import { FiMail, FiLock } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../assets/logo.png';

const StepMinhConta = ({ items, handleNextStep }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const logged = await login(email, password);
      if (logged) {
        handleNextStep();
        toast.success('Login realizado com sucesso!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
        });
      } else {
        toast.error('Falha ao fazer login. Verifique seus dados.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
        });
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      toast.error('Erro interno. Tente novamente.', {
        position: 'top-right',
        autoClose: 5000,
        theme: 'light',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <img src={logo || "/placeholder.svg"} alt='logo' className={styles.logo} />
          <h1 className={styles.title}>Entre na sua conta</h1>
          <p className={styles.subtitle}>
            Faça login para continuar com sua compra
          </p>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label className={styles.label}>E-mail ou CPF</label>
            <div className={styles.inputWrapper}>
              <FiMail className={styles.inputIcon} />
              <input
                type="text"
                value={email}
                onChange={handleEmailChange}
                className={styles.input}
                placeholder="Digite seu e-mail ou CPF"
                required
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.label}>Senha</label>
            <div className={styles.inputWrapper}>
              <FiLock className={styles.inputIcon} />
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
                className={styles.input}
                placeholder="Digite sua senha"
                required
              />
              <button
                type="button"
                className={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <BsEyeSlash /> : <BsEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || !email || !password}
            className={styles.loginButton}
          >
            {loading ? (
              <div className={styles.spinner}></div>
            ) : (
              <>
                <span>Entrar</span>
                <BsArrowUpRight />
              </>
            )}
          </button>
        </form>

        <div className={styles.divider}>
          <span>ou</span>
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            onClick={handleNextStep}
            className={styles.registerButton}
          >
            <span>Criar nova conta</span>
            <BsArrowUpRight />
          </button>

          <div className={styles.links}>
            <button className={styles.link}>
              Esqueceu a senha?
            </button>
            <button className={styles.link}>
              Precisa de ajuda?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepMinhConta;
